import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import { Button, Container } from 'reactstrap';
import { Breadcrumbs, Typography, IconButton, InputBase, Paper, Box, Tabs, Tab } from "@mui/material";
import PaginationTableWithFuncBtn from '../../../components/Util/PaginationTableWithFuncBtn';
import DeleteModal from '../../../components/Util/DeleteModal';
import '../../../../src/style/css/_project.css'
import toastAlert from '../../../js/Base/ToastAlert';
import AddIcon from "@mui/icons-material/Add";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchIcon from '@mui/icons-material/Search';
import { useSelector, useDispatch } from "react-redux";
import { getDocumentInfoList, getReportList, deleteDocumentInfo } from '../../../api/projectApi'
import DocumentSnInfoModal from './DocumentSnInfoModal';


export default function DocumentSnInfoManagement() {
  const [docList, setDocList] = useState([]);
  const [reportIdList, setReportIdList] = useState([]);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDoc, setselectedDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const userName = localStorage.getItem("user_email");
	const projectUuid = localStorage.getItem("project_uuid");


  const findDocById = (id) =>
    newDocList.find((doc) => String(doc.id) === String(id)) || null;

  const handleEdit = (id) => {
    const doc = findDocById(id);
    setselectedDoc(doc);
    setIsModalOpen(true);
  };

  const toggleModal = (id = null) => {
    setselectedDoc(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setselectedDoc(null);
  };

  const handleSearchChange = (e) => setSearch(e.target.value);

  const handleDelete = (id) => {
    const doc = findDocById(id);
    setDeleteTarget(doc);
    setDeleteModalOpen(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
    setDeleteTarget(null);
  };

  const handleDeleteDocument = async () => {
    if (!deleteTarget?.id) {
      toastAlert.autoClose(true).showError('找不到資料');
      return;
    }
    try {
      const data = await deleteDocumentInfo({
        acct_email: userName,
        id: deleteTarget.id,
        project_uuid: projectUuid,
      });
  
      if (data.success) {
        toastAlert.autoClose(true).showSuccess('刪除成功');
        setDeleteModalOpen(false);
        setDeleteTarget(null);
        fetchDocumentInfos();
      } else {
        toastAlert.autoClose(true).showError('刪除失敗');
      }
  
    } catch (error) {
      toastAlert.autoClose(true).showError('發生錯誤，請稍後再試');
    }
  };

  useEffect(() => {
    fetchMonthlyReportID();
    fetchDocumentInfos();
  }, []);

  const fetchDocumentInfos = async () => {
    setLoading(true);
    try {
      const data = await getDocumentInfoList({
        project_uuid: projectUuid,
        acct_email: userName
      });
      if (data.success) {
        setDocList(data.document || []);
      } else {
        toastAlert.autoClose(true).showError('發生錯誤，請稍後再試');
        setDocList([]);
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError('發生錯誤，請稍後再試');
    } finally {
      setLoading(false);
    }
  };

  const fetchMonthlyReportID = async () => {
    try {
      const data = await getReportList({project_uuid: projectUuid});
      if (data.success) {
        setReportIdList(data.report || []);
      } else {
        toastAlert.autoClose(true).showError('發生錯誤，請稍後再試');
        setReportIdList([]);
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError('發生錯誤，請稍後再試');
    }
  };

  const col_name = ['序號', '文件編號', '文件名稱', '動作'];

  const data_frame = [
    { keyName: 'document_sn', isBadge: false },
    { keyName: 'document_no', isBadge: false },
    { keyName: 'report_title', isBadge: false },
    { keyName: 'func', isClick: true, editBtn: true, delBtn: true },
  ];
  const col_size = ['15%', '30%', '32%', '23%'];

  const newDocList = docList.sort(function (a, b) {
    return a.document_sn - b.document_sn;
  });

  const filteredDocList = React.useMemo(() => {
    if (!search) return newDocList;
  
    return newDocList.filter((m) => {
      return (
        m.document_sn?.includes(search) ||
        m.document_no?.includes(search) ||
        m.report_title?.includes(search)
      );
    });
  }, [search, newDocList]);

  return (
    <React.Fragment>
      <Container className="mt-2">
        <div style={{ marginRight: '20px' }}>
          <Breadcrumbs
            className="link-area"
            style={{ padding: "0 0 20px 0", fontWeight: 'bold'}}
            separator={<NavigateNextIcon style={{ fontSize: '20px', fontWeight: 'bold' }} />}
            aria-label="breadcrumb"
          >
            <Link to="/admin-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>網站管理員設定</p>
            </Link>
            <Link to="/document-sn-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>文件編號管理</p>
            </Link>
          </Breadcrumbs>

          <>
            <div className="ProjectManagement">
              <Card>
                <Card.Header style={{ backgroundColor: "transparent" }}>
                  <strong>文件編號管理</strong>
                  {newDocList.length > 0 && (
                    <IconButton
                      onClick={() => toggleModal(null)}
                        sx={{
                          color: "black",
                          width: 32,
                          height: 32,
                        }}
                      >
                        <Typography variant="h6" component="span" sx={{ lineHeight: 1 }}>
                          <AddIcon fontSize="medium" />
                        </Typography>
                    </IconButton>
                  )}
                </Card.Header>
                <Card.Body style={{ paddingTop: "5px" }}>
                  <Row className="mb-3 mt-3">
                    <Col md={8}></Col>
                    <Col md={4}>
                      <Paper variant="outlined" component="form" sx={{ p: '2px 2px', display: 'flex', alignItems: 'left', height: '32px' }}>
                        <InputBase
                          sx={{ flex: 1, p: '10px' }}
                          style={{ fontSize: '12px', boxShadow: 'none' }}
                          placeholder="請輸入搜尋字串"
                          inputProps={{ 'aria-label': 'search keyword' }}
                          value={search}
                          onChange={handleSearchChange}
                        />
                        <IconButton type="button" sx={{ p: '12px' }} aria-label="search">
                          <SearchIcon style={{ color: '#E2E2E2' }} />
                        </IconButton>
                      </Paper>
                    </Col>
                  </Row>
                  {loading ? (
                    <div className="d-flex justify-content-center my-3">
                      <Spinner animation="border" role="status" />
                    </div>
                  ) : (
                    <>
                      {newDocList.length > 0 ? (
                        <PaginationTableWithFuncBtn
                          rowData={filteredDocList}
                          colName={col_name}
                          dataFrame={data_frame}
                          col_size={col_size}
                          editModalOpen={handleEdit}
                          delFunc={handleDelete}
                        />
                      ) : (
                        <Col md={12} className="d-flex justify-content-end align-items-center mt-2 mb-2">
                          <Button
                            style={{ width: '90px', height: '34px', fontSize: '14px', fontWeight: 'bold' }}
                            outline
                            onClick={() => toggleModal(null)}
                          >
                            新增
                          </Button>
                        </Col>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>


              <DocumentSnInfoModal
                isModalOpen={isModalOpen}
                handleClose={closeModal}
                isUpdate={!!selectedDoc}
                editData={selectedDoc}
                reportIdList={reportIdList}
                submitEffect={fetchDocumentInfos}
              />
              <DeleteModal
                  isModalOpen={deleteModalOpen}
                  handleClose={handleDeleteModalClose}
                  handleUpdate={handleDeleteDocument}
                  title={'刪除文編資訊'}
                  content={`確定刪除文編資訊：${deleteTarget?.report_title || ''}`}
                />
            </div>
          </>
        </div>
      </Container>
    </React.Fragment>
  );
}
